
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tc-owner",
      function () {
        return require("private-next-pages/tc-owner.js");
      }
    ]);
  